import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Avatar, Input, Button, Alert, message } from 'antd';
import { MD5 } from 'crypto-js';
import produce from  'immer';
import { post } from 'axios';
import S from './talkroom.module.less';

class TalkRoom extends Component {
  static defaultProps = {
    roomId: '',
    token: '',
    userInfo: null,

    onOpen: () => {},
    onMessage: () => {},
    onError: () => {},
  }

  state = {
    data: [],
    input: '',
    connected: false,
  }

  ws = null;
  recordRef = createRef();
  componentDidMount() {
    const { token, roomId } = this.props;
    this.ws = new WebSocket(`wss://www.kzmooc.com:9501?from_type=0&token=${token}&id=${roomId}&sign=${MD5(MD5(`${roomId}`).toString() + token).toString()}`);
  
    this.ws.onopen = (e) => {
      this.setState({
        connected: true,
      });
      this.props.onOpen(e);
    }

    this.ws.onclose = (e) => {
      this.setState({
        connected: false,
      });
      this.props.onError(e);
    }

    this.ws.onmessage = this.onMessageHandler;
  }

  componentWillUnmount() {
    this.ws.close();
  }

  onMessageHandler = (e) => {
    const data = JSON.parse(e.data);
    this.props.onMessage(e);
    this.setState(produce(draft => {
      draft.data.push(data);
    }))
  }
  
  componentDidUpdate(_prevProps, prevState) {
    if (this.state.data.length !== prevState.data.length) {
      const { current } = this.recordRef;
      if (current !== null) {
        current.scrollTop = current.scrollHeight - current.offsetHeight;
      }
    }
  }

  render() {
    const { data, input, connected } = this.state;
    const { userInfo } = this.props;

    return (
      <div className={S.talkRoom}>
        <div className={S.record} ref={this.recordRef}>
          {
            data.map((d, i) => (
              <div className={S.recordItem} key={i}>
                {this.renderRecord(d)}
              </div>
            ))
          }  
        </div>

        {
          userInfo !== null &&
            <div className={`${S.inputArea}`}>
              <Input
                size='large'
                value={input}
                onChange={this.inputChange}
                style={{ marginRight: 10 }}
                onPressEnter={this.send}
                // 0：未验证，1：已经验证， 2：验证不通过
                disabled={userInfo.is_verified !== 1 || !connected}
                placeholder={userInfo.is_verified !== 1 ? '未实名无法发言' : '输入发言'}
              />
              <Button
                size='large'
                onClick={this.send}
                disabled={userInfo.is_verified !== 1 || !connected}
              >
                发言
              </Button>
            </div>
        }
      </div>
    );
  }

  inputChange = (e) => {
    this.setState({
      input: e.target.value,
    })
  }

  send = async () => {
    const { input } = this.state;
    if (input === '') {
      message.error('发送内容不能为空');
      return;
    }

    try {
      const { data } = await post('sensitive-word/fifter-words', {
        words: input,
      })
  
      if (data.error_code !== 0) {
        message.error(data.message);
      } else {
        if (data.data.result !== 0) {
          message.error('有敏感词!');
          return;
        }
      }
    } catch (err) {
      throw err;
    }

    const msg = this.createMsg(input);
    this.ws.send(msg);
    this.setState({
      input: ''
    });
  }

  createMsg = (msg, status = 1, type = 0) => {
    const { token, roomId } = this.props;
    return JSON.stringify({
      msg,
      type,
      token,
      status,
      from_type: 0,
      id: roomId,
    })
  }

  // 0 一般用户
  // 1 系统通知
  // 2 管理员
  // 3 系统报错
  renderRecord = (d) => {
    switch (d.type) {
      case 0:
        return (
          <>
            <div className={S.avatar}>
              <Avatar size="large" src={d.user.avatar} />
            </div>
            <div className={S.content}>
              <p className={S.name}>{d.user.nickname}: </p>
              <p className={S.talk}>{d.msg}</p>
            </div>
          </>
        );
      case 1:
        return (
          <>
            <Alert message={`系统通知: ${d.msg}`} type="info" />
          </>
        );
      case 2:
        return (
          <>
            <Alert message={`管理员: ${d.msg}`} type="info" />
          </>
        );
      case 3:
        this.wxError(d);
        return null;
      default:
        return null;
    }
  }

  wxError(d) {
    console.error(d);
  }
}

const mapState = ({ loginInfo }) => ({
  token: loginInfo.access_token,
});

export default connect(mapState)(TalkRoom);
